module.exports = "\n<div>\n  <react-upgrade-plus />\n</div>\n\n";